import React, { useState } from 'react';
import { motion } from 'framer-motion';
const moods = [{
  label: 'Lost',
  color: '#95A5A6',
  message: "It's okay not to know the way. The path often reveals itself in silence."
}, {
  label: 'Overthinking',
  color: '#8E44AD',
  message: 'Breathe. Thoughts are just clouds passing through the sky of your mind.'
}, {
  label: 'Hopeful',
  color: '#F1C40F',
  message: "Hold onto that light. It's the dawn of something beautiful."
}, {
  label: 'Calm',
  color: '#2ECC71',
  message: 'Stay in this moment. Peace is your natural state.'
}, {
  label: 'Inspired',
  color: '#E67E22',
  message: 'Channel that energy. Create something that matters.'
}];
export function MoodSelector() {
  const [activeMood, setActiveMood] = useState<number | null>(null);
  return <section id="mood" className="py-24 px-6 bg-zen-bg relative overflow-hidden" data-id="element-78">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-79">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} className="text-5xl font-moon-dance text-zen-text mb-12" data-id="element-80">
          How are you feeling today?
        </motion.h2>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-81">
          {moods.map((mood, index) => <motion.button key={mood.label} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          scale: 1.05,
          backgroundColor: mood.color,
          color: '#fff',
          borderColor: mood.color
        }} whileTap={{
          scale: 0.95
        }} onClick={() => setActiveMood(index)} className={`px-6 py-3 rounded-full border border-zen-text/20 text-zen-text transition-colors duration-300 ${activeMood === index ? 'text-white border-transparent' : ''}`} style={{
          backgroundColor: activeMood === index ? mood.color : 'transparent',
          borderColor: activeMood === index ? mood.color : undefined
        }} data-id="element-82">
              {mood.label}
            </motion.button>)}
        </div>

        <div className="h-24 flex items-center justify-center" data-id="element-83">
          {activeMood !== null && <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} key={activeMood} className="text-xl md:text-2xl text-zen-text/80 font-light italic" data-id="element-84">
              "{moods[activeMood].message}"
            </motion.div>}
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-zen-accent/5 rounded-full blur-3xl -z-0" data-id="element-85" />
    </section>;
}